import * as React from 'react';
import { Icon } from 'ui/components';

interface Props {
    onClick?: () => void;
    children?: React.ReactNode;
    hoverType?: 'underline' | 'color';
    disableIcon?: boolean;
}

export class Tag extends React.PureComponent<Props> {

    public static defaultProps = {
        hoverType: 'underline',
    };

    public render() {
        const isInactive = this.props.onClick === undefined;
        return (
            <button
                className={`tag ${isInactive ? 'tag-inactive' : ''} ${this.props.hoverType ?? ''}`}
                onClick={() => this.props.onClick && this.props.onClick()}
                disabled={isInactive}
                type='button'
            >
                {this.props.children}
                {(!isInactive && !this.props.disableIcon) ? <Icon name='x' zoom='10'/> : null}
            </button>
        );
    }
}
